module.exports = __webpack_public_path__ + "33998db5cb59c224349e2116667f0473.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/pear@2x.png
// module id = 312
// module chunks = 0